import {useEffect, useState} from 'react'
import {useResetRecoilState, useSetRecoilState} from 'recoil'
import {TimeoutState, CertCheckState, VulnerableCheckState} from 'src/recoil/common'
import {TimerWrap} from 'src/styles/styledcomponent/views/mkt04/PhoneVerification'
import {useLocalModal} from "src/components/views/mkt04/Modal/provider";

const Timer = (props: { time: number }): JSX.Element => {
    const {time} = props
    const [minutes, setMinutes] = useState<number>(Math.floor(time / 60))
    const [seconds, setSeconds] = useState<number>(time % 60)
    const { openModal, closeModal } = useLocalModal()
    const ResetTimeOut = useResetRecoilState(TimeoutState)
    const setCertCheck = useSetRecoilState(CertCheckState)
    const setVulnerableCheck = useSetRecoilState(VulnerableCheckState)

    useEffect(() => {
        const countdown = setInterval(() => {
            if (Number(seconds) > 0) {
                setSeconds(Number(seconds) - 1)
            } else {
                if (Number(minutes) === 0) {
                    clearInterval(countdown)
                } else {
                    setMinutes(Number(minutes) - 1)
                    setSeconds(59)
                }
            }
        }, 1000)
        return () => clearInterval(countdown)
    }, [ResetTimeOut, minutes, seconds])

    useEffect(() => {
        if (minutes === 0 && seconds === 0) {
            setTimeout(() => {
                setCertCheck(false)
                setVulnerableCheck(false)
                setMinutes(0)
                setSeconds(0)
                ResetTimeOut()
                openModal({
                    width: '100%',
                    maxWidth: 300,
                    contents: {
                        title: '유효시간이 초과되었습니다. 인증번호를 다시 받으시기 바랍니다.'
                    },
                    actions: {
                        submit: {
                            text: "확인",
                            func: () => {
                                closeModal();
                            }
                        }
                    }
                })
            }, 1000)
        }
        // eslint-disable-next-line
    }, [minutes, seconds])
    return (
        <TimerWrap className={minutes === 0 ? 'danger' : ''}>
          0{minutes}:{seconds < 10 ? `0${seconds}` : seconds}
        </TimerWrap>
    )
}

export default Timer
